module.exports = __webpack_public_path__ + "assets/img/bjimg2.cd2299bc.png";